export default {
    "lang": "越南语",
    application: {
        name: 'Hệ thống phát thông tin',
    },
    ajaxTip: {
        success: 'Thành công',
        error: 'Thất bại',
        noAccess: 'Không có quyền truy cập tài nguyên này',
        notFound: 'Tài nguyên truy cập không tồn tại',
        serverBusy: 'Máy chủ đang bận',
        timeOut: 'Hết thời gian chờ',
    },
    menu: {
        home: 'Trang chủ',
        template: 'Quản lý mẫu',
        program: 'Quản lý chương trình',
        playplan: 'Kế hoạch phát',
        device: 'Quản lý thiết bị',
        "source-material": 'Quản lý tài liệu',
        material: 'Tài liệu',
        checkManage: 'Quản lý duyệt',
        setting: 'Cài đặt',
        usercenter: "Trung tâm người dùng",
        adminManage: "Quản lý thiết bị",
        schedule: "Công việc chờ xử lý",
        capitalassets: "Quản lý tài sản",
        modifyPassword: "Đổi mật khẩu",
        logout: "Đăng xuất",
        "add": "Thêm",
        "edit": "Chỉnh sửa",
        "delete": "Xóa",
        "view": "Xem",
        "menu_1": "Trang chủ",
        "menu_2": "Quản lý thiết bị",
        "menu_3": "Chỉnh sửa (Cài đặt nâng cao - Chỉnh sửa cơ bản - Thay đổi mạng)",
        "menu_4": "Lệnh tức thì",
        "menu_5": "Chỉnh sửa (Chuyển bộ phận)",
        "menu_6": "Chiến lược",
        "menu_7": "Cài đặt âm lượng",
        "menu_8": "Cài đặt độ sáng",
        "menu_9": "Cài đặt tải xuống",
        "menu_10": "Cài đặt ngủ đông",
        "menu_11": "Thuộc tính thiết bị",
        "menu_12": "Chỉnh sửa/Thêm",
        "menu_13": "Quản lý chương trình",
        "menu_14": "Lịch sử đăng tải",
        "menu_15": "Xóa (Đợt/Đơn lẻ)",
        "menu_16": "Chương trình đang đăng tải",
        "menu_17": "Nhóm hóa",
        "menu_19": "Danh sách chương trình",
        "menu_20": "Chỉnh sửa nội dung",
        "menu_21": "Sao chép chương trình",
        "menu_23": "Đăng tải chương trình",
        "menu_24": "Quản lý tài liệu",
        "menu_25": "Tải lên",
        "menu_28": "Đăng tải nhanh",
        "menu_29": "Quản lý mẫu",
        "menu_30": "Mẫu công cộng",
        "menu_31": "Sử dụng ngay",
        "menu_32": "Mẫu của tôi",
        "menu_33": "Đăng tải lên mẫu công cộng",
        "menu_35": "Lịch sử chia sẻ",
        "menu_36": "Quản lý kiểm duyệt",
        "menu_37": "Kiểm duyệt chương trình",
        "menu_38": "Kiểm duyệt (Phê duyệt/Từ chối)",
        "menu_39": "Kiểm duyệt tài liệu",
        "menu_41": "Lịch sử kiểm duyệt (Nhân viên vận hành)",
        "menu_42": "Lịch sử kiểm duyệt (Người kiểm duyệt)",
        "menu_43": "Xem số lượng phê duyệt",
        "menu_44": "Quản lý tổ chức",
        "menu_45": "Quản lý nhật ký",
        "menu_46": "Nhật ký phát lại",
        "menu_47": "Nhật ký đăng tải",
        "menu_48": "Nhật ký lỗi",
        "menu_49": "Nhật ký hoạt động",
        "menu_50": "Nhật ký tệp",
        "menu_51": "Nhật ký đăng nhập",
        "menu_52": "Phê duyệt nội dung",
        "menu_53": "Không gian lưu trữ",
        "menu_54": "Cơ cấu tổ chức",
        "menu_55": "Quyền vai trò",
        "menu_56": "Cấp quyền",
        "menu_57": "Xem (Quyền cấp quyền)",
        "menu_58": "Thành viên tổ chức",
        "menu_60": "Đặt lại mật khẩu người dùng cấp dưới",
        "menu_61": "Quản lý tài sản",
        "menu_62": "Số dư của tôi",
        "menu_63": "Xem (Chi tiết vốn)",
        "menu_64": "Dữ liệu sử dụng của tôi",
        "menu_65": "Xem (Chi tiết dữ liệu sử dụng)",
        "menu_66": "Mua dữ liệu sử dụng",
        "menu_67": "Dung lượng của tôi",
        "menu_68": "Thiết bị của tôi",
        "menu_69": "Chi tiết đơn hàng",
        "menu_70": "Xem (Nạp tiền)",
        "menu_71": "Xem (Mẫu đã mua)",
        "menu_72": "Xem (Dữ liệu sử dụng đã mua)",
        "menu_73": "Các quyền khác",
        "menu_74": "Xem (Thống kê tài liệu và chương trình)",
        "menu_75": "Xem (Tài sản)",
        "menu_76": "Xem (Dữ liệu đám mây/Thống kê)",
        "menu_77": "Xem (Thống kê thiết bị trực tuyến)"
    },
    login: {
        terminalServiceSystem: 'Hệ thống dịch vụ thiết bị đầu cuối thông minh',
        accountLogin: 'Đăng nhập bằng tài khoản',
        register: 'Đăng ký',
        accountLoginTip: 'Đã có tài khoản? Đăng nhập ngay',
        scanQRCode: 'Vui lòng quét mã QR',
        readAndAgree: 'Tôi đã đọc và đồng ý',
        readAndAgreeLink: 'Điều khoản dịch vụ người dùng',
        readAndAgreeAgreement: 'Vui lòng đọc và đồng ý điều khoản dịch vụ người dùng',
        forgetpassword: "Quên mật khẩu?",
        resetpassword: "Đặt lại mật khẩu",
        phoneEmptyTip: "Vui lòng nhập số điện thoại",
        nextStep: "Bước tiếp theo",
        title: 'Chào mừng đăng nhập',
        submit: 'Đăng nhập',
        userName: 'Tài khoản',
        password: 'Mật khẩu',
        userNameEmptyTip: 'Vui lòng nhập tài khoản',
        passwordEmptyTip: 'Vui lòng nhập mật khẩu',
        passwordFormatTip: 'Vui lòng nhập định dạng mật khẩu đúng',
        passwordIsOk: 'Vui lòng nhập mật khẩu xác nhận',
        passwordSign: 'Vui lòng nhập mật khẩu',
        codeTip: "Vui lòng nhập mã xác minh",
        phone: "Số điện thoại không được để trống",
        code: "Mã xác minh không được để trống",
        nickname: "Tên công ty không được để trống",
        pass: "Mật khẩu không được để trống",
        pwdMessage: "Mật khẩu có độ dài 8~20 ký tự, không chứa khoảng trắng và phải bao gồm 3 trong số các loại sau: chữ hoa, chữ thường, số, ký tự đặc biệt",
        pwdMessage01: "Vui lòng nhập mật khẩu có ít nhất 8 ký tự bao gồm chữ và số",
        pwdMessage02: "Mật khẩu có độ dài 8-20 ký tự",
        pwdMessage03: "Mật khẩu không được chứa khoảng trắng",
        pwdMessage04: "Mật khẩu phải bao gồm 3 trong số các loại sau: chữ hoa, chữ thường, số, ký hiệu",
        newpassempty: "Mật khẩu mới không được để trống",
        newpass: "Hai lần nhập mật khẩu không khớp",
        getcode: "Lấy mã xác minh",
        format: "Định dạng số điện thoại không đúng",
        chongfa: "Gửi lại sau giây",
        isSend: 'Đã gửi',
        noregister: "Chưa có tài khoản? Đăng ký ngay",
        Mobile: "Số điện thoại",
        verificationcode: "Mã xác minh",
        petname: "Biệt danh",
        Quickregistration: "Đăng ký nhanh",
        xiugaimima: "Đổi mật khẩu",
        jiumima: "Mật khẩu cũ",
        xinmima: "Mật khẩu mới",
        zaicishuruxinmima: "Nhập lại mật khẩu mới",
        xiugaichenggong: "Đổi thành công",
        xiugaishoujihao: "Đổi số điện thoại",
        dengluzhanghao: "Tài khoản đăng nhập",
        gongsiid: "ID công ty",
        yonghunicheng: "Biệt danh người dùng",
        chuangjianshijian: "Thời gian tạo",
        gongsimingcheng: "Tên công ty",
        denglumima: "Mật khẩu đăng nhập",
        jianyi: "Khuyến nghị sử dụng mật khẩu kết hợp chữ và số",
        shezhimima: "Đặt mật khẩu",
        shezhishoujihao: "Đổi/Cập nhật số điện thoại",
        yibangding: "Đã liên kết",
        weibangding: "Chưa liên kết",
        zhanghuanquan: "An toàn tài khoản",
        yonghuxinxi: "Thông tin người dùng",
        zhuceSucMsg: 'Chúc mừng, đăng ký thành công!',
        verificationcodeSucMsg: "Gửi mã xác minh thành công！",
        requiredIsEmpty: "Trường bắt buộc không được để trống！",
        emailObj: {
            title: 'Email',
            tit: 'Đăng nhập bằng Email',
            tip: 'Vui lòng nhập địa chỉ Email',
            formatTip: 'Vui lòng nhập định dạng Email đúng',
        },
        phoneObj: {
            title: 'Số điện thoại',
            tit: 'Đăng nhập bằng số điện thoại',
            tip: 'Vui lòng nhập số điện thoại',
            formatTip: 'Vui lòng nhập định dạng số điện thoại đúng',
        },
        emailOrPhoneObj: {
            title: 'Email hoặc số điện thoại',
            tit: 'Đăng nhập bằng Email hoặc số điện thoại',
            tip: 'Vui lòng nhập Email hoặc số điện thoại',
            formatTip: 'Vui lòng nhập định dạng Email hoặc số điện thoại đúng',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Đăng nhập bằng WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Đăng nhập bằng Google',
        },
        confirm: 'Xác nhận',
        confirmSubmit: 'Xác nhận gửi',
        cancel: 'Hủy',
        close: 'Đóng',
        bindSucMsg: 'Liên kết thành công',
        toContinueBindAccount: 'Tiếp tục để hoàn tất liên kết tài khoản thứ ba',
        bindTip01: 'Chưa có tài khoản? Đăng ký ngay',
        bindTip02: 'Đã có tài khoản',
        bindTip03: 'Tài khoản thứ ba hiện tại chưa liên kết với tài khoản nền tảng, vui lòng liên kết tài khoản đã có hoặc đăng ký liên kết tài khoản mới, lần sau có thể đăng nhập nhanh.',
        bindTip04: 'Liên kết tài khoản đã có',
        bindTip05: 'Đăng ký và liên kết tài khoản mới',
        bindTip06: 'Bạn đã được ủy quyền qua bên thứ ba, vui lòng hoàn thiện thông tin đăng nhập sau để hoàn tất liên kết',
        bindSubmit: 'Gửi liên kết',
        enterAccountTip: 'Vui lòng nhập tên tài khoản',
        RegisterAndBind: 'Đăng ký và liên kết',
        loginErr: 'Tên người dùng hoặc mật khẩu sai！',
        usercenter: "Trung tâm người dùng",
        pleaseInputName: "Vui lòng nhập tên",
        operationSuccess: "Thao tác thành công！",
        edit: "Chỉnh sửa",
        xiugai: "Sửa đổi",
        userData: "Thông tin cá nhân",
        changePassword: "Đổi mật khẩu",
        account: "Tài khoản",
        userName01: "Tên người dùng",
        phoneNumber: "Số điện thoại",
        role: "Vai trò",
        createTime: "Thời gian tạo",
        genghuang: "Thay đổi",
        bangding: "Liên kết",
        unbind: "Hủy liên kết",
        plesaseSelectBindingType: "Vui lòng chọn loại liên kết",
        pleaseConfirmCont: "Vui lòng xác nhận tôi đã đọc nội dung này",
        confirmReadCont: "Tôi đã đọc nội dung này",
        frequentTip: "Thao tác quá thường xuyên, vui lòng thử lại sau!",
        zhuxiaoBtn: "Hủy tài khoản",
        zhuxiaoTitle: "Hủy tài khoản",
        querenZhuxiao: "Xác nhận hủy",
        jiXu: "Tiếp tục",
        sendCodeBtn: "Gửi mã xác minh",
        passwordIsNotOldPassword: "Mật khẩu xác nhận không khớp với mật khẩu mới",
        passwordIsOldPassword: "Mật khẩu mới trùng với mật khẩu cũ",
        passFormatError: "Vui lòng nhập định dạng mật khẩu đúng",
        oldPassWord: "Mật khẩu cũ",
        newPassWord: "Mật khẩu mới",
        inputPlaceholder: 'Vui lòng nhập',
        confirmPassword: "Xác nhận mật khẩu",
        zhuxiaoTip: `
            1、Việc hủy tài khoản là hành động không thể khôi phục, một khi tài khoản bị hủy, bạn sẽ không thể đăng nhập và sử dụng tài khoản này hoặc tài khoản thứ ba đăng ký/login thông qua tài khoản này nữa, vui lòng sao lưu thông tin và dữ liệu liên quan đến tài khoản một cách tự chủ.
            2、Trước khi đăng ký tài khoản này, vui lòng đảm bảo đã xóa tất cả tài sản và không có bất kỳ tranh chấp nào; một khi tài khoản này bị hủy, tức là bạn từ bỏ quyền sở hữu tất cả tài sản và quyền lợi trong tài khoản này, và không thể khôi phục hoặc lấy lại.
            3、Nếu tổng số tài khoản đăng ký bằng cùng một số điện thoại bị hủy đủ 3 lần, số điện thoại này sẽ không thể đăng ký tài khoản mới nữa, đồng thời cũng không thể liên kết với bất kỳ tài khoản nào khác.
        `
    },
    home: {
        title: "Trang chủ",
        quickOperation: "Thao tác nhanh",
        addDevice: "Thêm thiết bị",
        publishProgram: "Phát chương trình",
        publishMaterial: "Phát tài liệu",
        makeProgram: "Tạo chương trình",
        uploadMaterial: "Tải lên tài liệu",
        todayData: "Dữ liệu hôm nay (cập nhật mỗi giờ)",
        playNumChart: "Thống kê số lần phát",
        deviceOnlineStatus: "Trạng thái trực tuyến của thiết bị",
        onLineDevice: "Thiết bị trực tuyến",
        unLineDevice: "Thiết bị ngoại tuyến",
        programPlayTime: "Thống kê thời gian phát chương trình",
        downloadSoft: "Tải phần mềm",
        adminApp: "Ứng dụng người dùng di động",
        playerApp: "Thiết bị đầu cuối phát thông tin",
        downloadAdminApp: "Nhấn để tải ứng dụng người dùng",
        downloadPlayerApp: "Nhấn để tải ứng dụng phát",
        aboutUs: "Về chúng tôi",
        userManual: "Hướng dẫn sử dụng",
        message: "Tôi muốn gửi tin nhắn",
    },
    device: {
        inputPlaceholder: 'Vui lòng nhập',
        selectPlaceholder: 'Vui lòng chọn',
        osTypeStr: 'Hệ thống thiết bị đầu cuối',
        onLineStatus: 'Trạng thái trực tuyến',
        dpi: 'Độ phân giải',
        companyDeptIdName: 'Tổ chức thuộc về',
        deviceGroupIdName: 'Nhóm thuộc về',
        editOrMove: 'Chỉnh sửa/Chuyển',
        loanOriginationFee: 'Phí xử lý vay',
        strategyInfoLook: 'Xem thông tin chiến lược',
        programLook: 'Xem chương trình',
        addEquipments: 'Thêm thiết bị',
        luminanceSet: 'Điều khiển độ sáng',
        terminal: 'Cài đặt thiết bị đầu cuối',
        transferCompany: 'Chuyển phòng ban',
        releasedProgram: 'Phát chương trình',
        screenshot: 'Chụp màn hình',
        changeGroup: 'Thay đổi nhóm',
        defaultGroup: "Nhóm mặc định",
        operation: "Thao tác",
        edit: "Chỉnh sửa",
        saveEdit: "Lưu chỉnh sửa",
        add: "Thêm",
        save: "Lưu",
        setting: "Cài đặt",
        program: "Chương trình",
        unbind: "Hủy liên kết",
        sleep: "Ngủ đông",
        wakeup: "Kích hoạt",
        restart: "Khởi động lại",
        shutdown: "Tắt máy",
        reportLog: "Báo cáo nhật ký",
        clearPlayData: "Xóa dữ liệu thiết bị phát",
        offlineWarn: "Thiết bị này đã ngoại tuyến, vui lòng thử lại sau khi thiết bị trực tuyến！",
        confirmUnbind: "Xác nhận hủy liên kết",
        confirmReset: "Xác nhận xóa",
        confirmDelete: "Xác nhận xóa",
        delete: "Xóa",
        cancelDelete: "Hủy xóa",
        confirmResetSuccess: "Xóa thành công",
        confirm: "Xác nhận",
        cancel: "Hủy",
        operationSuccess: "Thao tác thành công",
        unbindSuccess: "Hủy liên kết thành công",
        pleaseSelectDevice: "Vui lòng chọn thiết bị",
        pleaseSelectOnlineDevice: "Vui lòng chọn thiết bị trực tuyến",
        confirmMixOperation: "Các thiết bị đã chọn bao gồm thiết bị ngoại tuyến, cài đặt này không có hiệu lực đối với thiết bị ngoại tuyến, xác nhận tiếp tục thao tác？",
        pleaseSelectDate: "Vui lòng chọn ngày",
        reportSuccess: "Báo cáo thành công",
        deviceSetting: "Cài đặt thiết bị",
        default: "Mặc định",
        all: "Tất cả",
        deviceList: "Danh sách thiết bị",
        addDevice: "Thêm thiết bị",
        department: "Cơ quan phòng ban",
        deviceType: "Độ phân giải",
        osType: "Hệ thống thiết bị đầu cuối",
        onlineState: "Trạng thái trực tuyến",
        online: "Trực tuyến",
        offline: "Ngoại tuyến",
        notActive: "Chưa kích hoạt",
        search: "Vui lòng nhập từ khóa",
        batchOperation: "Thao tác hàng loạt",
        allDevices: "Tất cả thiết bị",
        deviceAttribute: "Thuộc tính thiết bị",
        selectReportDate: "Chọn ngày báo cáo",
        inputName: "Vui lòng nhập tên",
        inputWidth: "Vui lòng nhập chiều rộng",
        inputHeight: "Vui lòng nhập chiều cao",
        inputResolutionRatio: "Vui lòng nhập số nguyên lớn hơn 0！",
        inputSort: "Vui lòng nhập thứ tự sắp xếp",
        serialNum: "Số thứ tự",
        name: "Tên",
        width: "Chiều rộng",
        height: "Chiều cao",
        resolutionRatio: "Độ phân giải",
        inputResolutionRatioName: "Vui lòng nhập tên độ phân giải",
        sort: "Thứ tự sắp xếp",
        personal: "Cá nhân",
        system: "Hệ thống",
        type: "Loại",
        systemDefaultSettingUneditable: "Cài đặt mặc định của hệ thống không thể chỉnh sửa!",
        systemDefaultSettingUnDeletable: "Cài đặt mặc định của hệ thống không thể xóa!",
        newz: "Thêm mới",
        total: "Tổng cộng",
        totalNum: "bản ghi",
        strategyName: "Tên chiến lược",
        associatedTerminalNum: "Số lượng thiết bị đầu cuối liên kết",
        createTime: "Thời gian tạo",
        pleaseSelectStrategy: "Vui lòng chọn chiến lược！",
        onlySelectOneData: "Chỉ có thể chọn một bản ghi！",
        downloadStrategy: "Tải chiến lược",
        inputStrategyName: "Vui lòng nhập tên chiến lược",
        luminanceControl: "Điều khiển độ sáng",
        volumeStrategy: "Chiến lược âm lượng",
        saveSuccess: "Lưu thành công",
        screenAngle: "Xoay màn hình(°)",
        startTime: "Thời gian bắt đầu",
        endTime: "Thời gian kết thúc",
        repeat: "Lặp lại",
        monday: "Thứ Hai",
        tuesday: "Thứ Ba",
        wednesday: "Thứ Tư",
        thursday: "Thứ Năm",
        friday: "Thứ Sáu",
        saturday: "Thứ Bảy",
        sunday: "Chủ Nhật",
        everyday: "Mỗi ngày",
        downloadSpeed: "Tốc độ tải",
        inputDownloadSpeed: "Vui lòng nhập tốc độ tải",
        operator: "Thao tác",
        pleaseSelectDeleteData: "Vui lòng chọn dữ liệu cần xóa！",
        confirmBatchDelete: "Xác nhận xóa hàng loạt？",
        pleaseInputName: "Vui lòng nhập tên",
        detailSetting: "Cài đặt chi tiết",
        weekPlan: "Kế hoạch tuần",
        specialDateSetting: "Cài đặt ngày đặc biệt",
        weekdayInfo: "Thứ trong tuần là trường bắt buộc!",
        volumeInfo: "Âm lượng là trường bắt buộc!",
        timeError: "Lỗi chọn thời gian!",
        editSuccess: "Chỉnh sửa thành công！",
        addSuccess: "Thêm thành công！",
        addSpecialPlan: "Thêm kế hoạch chiến lược đặc biệt",
        downloadSpeedInfo: "Tốc độ tải:(0 nghĩa là cấm tải)",
        pleaseSelectStartTime: "Vui lòng chọn thời gian bắt đầu",
        pleaseSelectEndTime: "Vui lòng chọn thời gian kết thúc",
        luminanceError: "Vui lòng nhập giá trị độ sáng đúng！",
        defaultLuminance: "Độ sáng mặc định",
        luminance: "Mức độ sáng",
        defaultLuminanceInfo: "Độ sáng mặc định(100 là sáng nhất,0 là tối nhất)",
        volume: "Âm lượng",
        saveLuminance: "Lưu độ sáng",
        changeSuccess: "Thay đổi thành công！",
        changeNetwork: "Thay đổi mạng",
        netName: "Tên mạng",
        nameempty: "Tên mạng không được để trống",
        currentNetwork: "Mạng hiện tại",
        ipAddress: "Địa chỉ IP",
        dailyMode: "Chế độ hàng ngày",
        weeklyMode: "Chế độ hàng tuần",
        turnOnTime: "Thời gian bật máy",
        turnOffTime: "Thời gian tắt máy",
        startSleep: "Bắt đầu ngủ đông",
        endSleep: "Kết thúc ngủ đông",
        batchDelInfo: "Xác nhận xóa các mục đã chọn？",
        timeCannotBeEmpty: "Thời gian không được để trống!",
        startUp: "Bật máy",
        shutDown: "Tắt máy",
        volumeSize: "Mức âm lượng",
        defaultVolume: "Âm lượng mặc định(100 là lớn nhất,0 là tắt tiếng)",
        chooseStartTime: "Vui lòng chọn thời gian bắt đầu",
        chooseEndTime: "Vui lòng chọn thời gian kết thúc",
        saveVolume: "Lưu âm lượng",
        screenRotationUnSaved: "Xoay màn hình chưa lưu",
        volumeSettingUnSaved: "Cài đặt âm lượng chưa lưu",
        luminanceSettingUnSaved: "Cài đặt độ sáng chưa lưu",
        confirmClosePopup: "Xác nhận đóng cửa sổ này?",
        volumeSettingSuccess: "Sửa đổi âm lượng thành công",
        luminanceSettingSuccess: "Sửa đổi độ sáng thành công",
        advancedSettingUnSaved: "Cài đặt nâng cao chưa lưu",
        settingTitle: "Cài đặt thiết bị đầu cuối",
        volumeSetting: "Cài đặt âm lượng",
        luminanceSetting: "Cài đặt độ sáng",
        downloadSetting: "Cài đặt tải",
        sleepSetting: "Cài đặt ngủ đông",
        onOffSetting: "Bật/tắt theo lịch",
        screenRotation: "Xoay màn hình",
        namingError: "Lỗi đặt tên, tên tệp không được có khoảng trắng！",
        deleteSuccess: "Xóa thành công",
        deleteFolder: "Xóa thư mục",
        pleaseInputDeviceName: "Vui lòng nhập tên thiết bị",
        pleaseInputDeviceId: "Vui lòng nhập ID thiết bị",
        discoverDevice: "Tìm thiết bị",
        deviceId: "ID thiết bị",
        bound: "Đã liên kết",
        bind: "Liên kết",
        noDevice: "Không có thiết bị",
        refresh: "Làm mới",
        manualAdd: "Thêm thủ công",
        deviceGroup: "Phân loại thiết bị",
        pleaseSelectGroup: "Vui lòng chọn nhóm！",
        deviceName: "Tên thiết bị",
        goAdd: "Đi đến thêm",
        close: "Đóng",
        bindCountInsufficient: "Số lượng có thể liên kết không đủ, vui lòng nâng cấp số lượng thiết bị trước khi thêm！",
        displayNumber: "Mã hiển thị",
        groupName: "Tên nhóm",
        pleaseSelectGroupName: "Vui lòng nhập tên nhóm！",
        moveGroup: "Chuyển nhóm",
        longitude: "Kinh độ",
        latitude: "Vĩ độ",
        nationality: "Quốc tịch",
        province: "Tỉnh",
        city: "Thành phố",
        county: "Huyện",
        outNetIp: "IP ngoài mạng",
        inNetIp: "IP trong mạng",
        companyName: "Tên doanh nghiệp",
        Info: "Chi tiết",
        android: "Android",
        win: "Windows",
        osVersion: "Phiên bản hệ thống",
        softwareVersion: "Phiên bản phần mềm",
        diskSize: "Kích thước đĩa",
        useSize: "Kích thước đã sử dụng",
        macAddr: "Địa chỉ MAC",
        longitudeLatitudeInfo: "Kinh độ và vĩ độ phải cùng để trống hoặc cùng không để trống!",
        terminalName: "Tên thiết bị đầu cuối",
        terminalGroup: "Nhóm thiết bị đầu cuối",
        reportJournal: "Có báo cáo hay không",
        systemVersion: "Phiên bản hệ thống",
        storageSpace: "Không gian lưu trữ",
        resolution: "Độ phân giải",
        runningMemory: "Bộ nhớ chạy",
        model: "Mô hình",
        registerStatus: "Trạng thái đăng ký",
        password: "Mật khẩu",
        passwordInfo: "Vui lòng nhập 6 đến 18 chữ hoặc số!",
        group: "Nhóm",
        address: "Địa chỉ",
        remark: "Ghi chú",
        renewalPeriod: "Chu kỳ gia hạn",
        money: "Chi phí",
        latitudeInfo: "Vui lòng nhập vĩ độ đúng!",
        totalPayment: "Tổng số tiền thanh toán",
        longitudeInfo: "Vui lòng nhập kinh độ đúng!",
        setMeal: "Gói dịch vụ",
        number: "Số lượng",
        programName: "Tên chương trình",
        playStatus: "Trạng thái phát",
        playType: "Cách phát",
        play: "Phát",
        pause: "Tạm dừng",
        playTime: "Thời gian phát",
        programDeleted: "Chương trình đã bị xóa",
        playSuccess: "Chương trình đã được sắp xếp phát",
        pauseSuccess: "Tạm dừng thành công",
        playCycle: "Phát lặp",
        playInsert: "Chèn phát",
        withdrawSuccess: "Thu hồi thành công",
        withdrawInfo: "Vui lòng chọn chương trình cần thu hồi trước！",
        programBelong: "Chương trình thuộc về",
        checkAll: "Chọn tất cả",
        batchDel: "Xóa hàng loạt",
        delConfirm: "Xác nhận xóa các mục đã chọn？",
        check: "Đã chọn",
        noProgram: "Không có chương trình",
        details: "Chi tiết",
        screenshotFail: "Chụp màn hình thất bại",
        policyName: "Tên chính sách",
        terminalNum: "Số lượng thiết bị đầu cuối liên kết",
        powerStrategy: "Chiến lược nguồn",
        pleaseSelectDepartment: "Vui lòng chọn phòng ban！",
        screenshotControl: "Điều khiển chụp màn hình",
        未激活: "Chưa kích hoạt",
        已激活: "Đã kích hoạt",
        未绑定: "Chưa liên kết",
        已绑定: "Đã liên kết",
    },
    programManage: {
        programList: "Danh sách chương trình",
        publishProgram: "Theo dõi phát chương trình",
        week1: "Thứ Hai",
        week2: "Thứ Ba",
        week3: "Thứ Tư",
        week4: "Thứ Năm",
        week5: "Thứ Sáu",
        week6: "Thứ Bảy",
        week7: "Chủ Nhật",
        monday: "Thứ Hai",
        tuesday: "Thứ Ba",
        wednesday: "Thứ Tư",
        thursday: "Thứ Năm",
        friday: "Thứ Sáu",
        saturday: "Thứ Bảy",
        sunday: "Chủ Nhật",
        name: "Tên",
        preview: "Xem trước",
        playDeviceNum: "Số thiết bị phát",
        copyDeviceCode: "Nhấn để sao chép",
        osType: "Loại hệ thống",
        playDate: "Ngày phát",
        playWeek: "Tuần phát",
        everyday: "Mỗi ngày",
        start: "Từ",
        end: "Đến",
        playOperateStatusStr: "Trạng thái phát",
        playDevice: "Thiết bị phát",
        downloadView: "Xem tải",
        publisher: "Người phát",
        publishTime: "Thời gian phát",
        operation: "Thao tác",
        add: "Thêm",
        groupName: "Tên nhóm",
        selectDevice: "Chọn thiết bị đầu cuối",
        searchDevice: "Tìm thiết bị đầu cuối",
        pleaseFillGroupName: "Vui lòng nhập tên nhóm！",
        remarkInfo: "Ghi chú",
        compile: "Chỉnh sửa",
        withdrawConfirm: "Xác nhận thu hồi chương trình này？",
        confirm: "Xác nhận",
        cancel: "Hủy",
        withdraw: "Thu hồi",
        batchWithdraw: "Thu hồi hàng loạt",
        batchPublish: "Phát hàng loạt",
        batchDelete: "Xóa hàng loạt",
        batchOperation: "Thao tác hàng loạt",
        notUse: "Chưa sử dụng",
        notChecked: "Chưa duyệt",
        notPass: "Không duyệt",
        delete: "Xóa",
        publishTextLeft: "Đã phát",
        offTextLeft: "Đã tạm dừng",
        pleaseSelectProgramToMove: "Vui lòng chọn chương trình cần chuyển！",
        pause: "Tạm dừng",
        pauseConfirm: "Xác nhận tạm dừng？",
        play: "Phát",
        downloadUdisk: "Tải U盘",
        deviceList: "Danh sách thiết bị",
        groupSelection: "Chọn nhóm",
        operationSuccess: "Thao tác thành công",
        deleteSuccess: "Xóa thành công",
        selectDate: "Chọn ngày",
        publishStatus: "Trạng thái phát",
        checkStatus: "Trạng thái duyệt",
        waitAuditing: "Chờ duyệt",
        auditPass: "Đã duyệt",
        auditRefuse: "Từ chối duyệt",
        all: "Tất cả",
        playStatus: "Đang phát",
        playStatust: "Trạng thái phát",
        pauseStatus: "Đã tạm dừng",
        notStartStatus: "Chưa bắt đầu",
        resolutionratio: "Độ phân giải",
        totalNum: "bản ghi",
        programName: "Tên chương trình",
        playStartTime: "Thời gian bắt đầu phát",
        playEndTime: "Thời gian kết thúc phát",
        createTime: "Thời gian tạo",
        nationality: "Quốc tịch",
        province: "Tỉnh/thành phố",
        city: "Thành phố",
        county: "Quận/huyện",
        address: "Địa chỉ",
        ip: "Địa chỉ IP",
        location: "Vị trí",
        log: "Nhật ký",
        pleaseFillProgramName: "Vui lòng nhập tên chương trình！",
        selectGroup: "Chọn nhóm",
        startTime: "Thời gian bắt đầu",
        endTime: "Thời gian kết thúc",
        publishCycle: "Chu kỳ phát",
        publishDeviceNum: "Số thiết bị phát",
        pleaseSelectRecord: "Vui lòng chọn bản ghi",
        deviceName: "Tên thiết bị đầu cuối",
        deviceId: "ID thiết bị đầu cuối",
        deviceGroupIdName: "Nhóm thuộc về",
        notClassified: "Chưa phân loại",
        osTypeStr: "Hệ thống thiết bị đầu cuối",
        storageSpace: "Không gian lưu trữ",
        onLineStatus: "Trạng thái trực tuyến",
        onLine: "Trực tuyến",
        offLine: "Ngoại tuyến",
        sleep: "Ngủ đông",
        unknown: "Không xác định",
        registerStatus: "Trạng thái đăng ký",
        trialPeriod: "Giai đoạn dùng thử",
        notActive: "Chưa kích hoạt",
        active: "Đã kích hoạt",
        parameterError: "Tham số sai!",
        pleaseSelectProgram: "Vui lòng chọn chương trình!",
        pleaseSelectProgramEdit: "Vui lòng chọn chương trình cần chỉnh sửa!",
        confirmWithdrawSelectedProgram: "Xác nhận thu hồi các chương trình đã chọn？",
        withdrawSuccess: "Thu hồi thành công",
        allPrograms: "Tất cả chương trình",
        defaultGroup: "Nhóm mặc định",
        cannotShareEmptyProgram: "Không thể chia sẻ chương trình trống！",
        onlyShareYourProgram: "Chỉ có thể chia sẻ chương trình do bạn tạo!",
        pleaseSelectProgramEditPublishTime: "Vui lòng chọn chương trình đã chỉnh sửa thời gian phát!",
        pleaseSelectDevice: "Vui lòng chọn thiết bị!",
        programDetail: "Chi tiết chương trình",
        errorReason: "Lý do lỗi",
        availableStorageSpaceInsufficient: "Không gian lưu trữ khả dụng không đủ",
        partialDeviceReleaseFailure: "Phát thất bại trên một số thiết bị",
        allDeviceReleaseSuccess: "Phát thành công trên tất cả thiết bị",
        partialDeviceReleaseSuccess: "Phát thành công trên một số thiết bị",
        allGroup: "Tất cả nhóm",
        allProgram: "Tất cả chương trình",
        unGrouped: "Chưa nhóm",
        replaceProgram: "Thay thế chương trình",
        replaceProgramTip: "Chương trình phát mới sẽ thay thế dữ liệu chương trình đã gửi trên thiết bị phát！",
        screen: "Màn hình đơn/cặp",
        singleScreen: "Màn hình đơn",
        doubleScreen: "Màn hình kép",
        playSetting: "Cài đặt phát",
        batchPlaySetting: "Cài đặt thời gian phát hàng loạt",
        individualPlaySetting: "Cài đặt thời gian phát từng chương trình",
        playTime: "Thời gian phát",
        daily: "Mỗi ngày",
        weekdays: "Thứ Hai đến Thứ Sáu",
        monthly: "Trong tháng",
        advancedSetting: "Cài đặt nâng cao",
        playProgram: "Phát chương trình",
        searchProgram: "Vui lòng nhập từ khóa",
        shareAddressNotExist: "Địa chỉ liên kết không tồn tại, vui lòng thử lại",
        copySuccess: "Sao chép thành công",
        shareLink: "Liên kết chia sẻ",
        publish: "Phát",
        noResource: "Không có tài nguyên",
        single: "Màn hình đơn",
        double: "Màn hình kép",
        time: "Thời gian",
        associatedTerminalNum: "Số lượng thiết bị đầu cuối liên kết",
        default: "Mặc định",
        moveGroup: "Chuyển nhóm",
        pleaseSelectGroup: "Vui lòng nhập tên nhóm！",
        copy: "Sao chép",
        FUBEN: "Bản sao",
        nameempty: "Tên không được để trống",
        whitespace: "Lỗi đặt tên, tên tệp không được có khoảng trắng！",
        programWhitespace: "Lỗi đặt tên, tên chương trình không được có khoảng trắng！",
        pleaseSelectResolution: "Vui lòng chọn độ phân giải！",
        dataError: "Dữ liệu sai！",
        createProgram: "Tạo chương trình mới",
        directCreate: "Tạo trực tiếp",
        myTemplate: "Mẫu của tôi",
        use: "Sử dụng",
        free: "Miễn phí",
        loadMore: "Tải thêm",
        confirmDelete: "Xác nhận xóa",
        deleteGroup: "Xóa nhóm",
        notPublished: "Chưa phát",
        notPassed: "Không duyệt",
        notUsed: "Chưa sử dụng",
        confirmDeleteSelectedProgram: "Xác nhận xóa các chương trình đã chọn？",
        companyName: "Tên doanh nghiệp",
        programCannotDownload: "Chương trình này không thể tải！",
        publishMaterial: "Phát tài liệu",
        playMaterial: "Phát tài liệu",
        pleaseInputMaterialName: "Vui lòng nhập tên tài liệu",
        size: "Kích thước",
        pleaseInputDeviceName: "Vui lòng nhập tên thiết bị",
        item: "bản ghi",
        allMaterial: "Tất cả tài liệu",
        allDevices: "Tất cả thiết bị",
        "saveSuccess": "Lưu thành công",
        "savefaill": "Lưu thất bại",
        "playMode": "Chế độ phát",
        "cyclePlay": "Phát lặp lại",
        "insertPlay": "Chèn phát",
        "noData": "Không có dữ liệu",
        "Add": "Thêm mới",
        "replace": "Thay thế",
        "repeat": "Lặp lại",
        "start01": "Bắt đầu",
        "end01": "Kết thúc",
        "startDate": "Ngày bắt đầu",
        "endDate": "Ngày kết thúc",
        "useNow": "Sử dụng ngay",
        "fillStartEndTimeFirst": "Vui lòng điền đầy đủ thời gian bắt đầu và kết thúc trước khi thêm",
        "fillFullPlayTime": "Vui lòng điền đầy đủ thời gian phát",
        "fillCorrectPlayTime": "Vui lòng điền khoảng thời gian phát chính xác",
        "sDateAndEDateBothEmptyOrFilled": "Ngày bắt đầu và ngày kết thúc phải cùng trống hoặc cùng được điền"
    },
    source: {
        addResource: "Thêm tài nguyên",
        width: "Chiều rộng",
        height: "Chiều cao",
        size: "Kích thước(KB)",
        name: "Tên",
        pleaseInputResourceName: "Vui lòng nhập tên tài nguyên！",
        addToGroup: "Thêm vào nhóm",
        remark: "Ghi chú",
        promptFgIllustrate: "Họa tiết",
        promptFgRealisticPhoto: "Ảnh thực tế",
        promptFgSimplisticDrawing: "Biểu đồ đơn giản",
        promptFgChineseStyle: "Phong cách Trung Quốc",
        promptFgPixelArt: "Pixel art",
        noModel: "Không có mô hình, vui lòng liên hệ quản trị viên！",
        getModelFailed: "Lấy mô hình thất bại, vui lòng thử lại sau！Hoặc liên hệ quản trị viên！",
        createImagePrompt: "Đang tạo ảnh, vui lòng không đóng cửa sổ！",
        promptEmpty: "Vui lòng nhập từ gợi ý",
        dpiEmpty: "Vui lòng chọn tỷ lệ ảnh！",
        fgEmpty: "Vui lòng chọn phong cách！",
        style: "Phong cách",
        idEmpty: "ID ảnh không được để trống",
        exist: "Ảnh này đã tồn tại trong tài liệu",
        addSuccess: "Thêm tài liệu thành công",
        saveError: "Lưu ảnh thất bại, vui lòng thử lại sau！",
        delSuccess: "Xóa thành công",
        generateImage: "Tạo ảnh từ văn bản",
        generateImagePlaceholder: 'Vui lòng nhập ảnh bạn muốn tạo, ví dụ: Một con bướm vẫy cánh bay trong cánh hoa',
        aiExpand: "Mở rộng thông minh",
        negativePrompt: "Từ gợi ý ngược",
        negativePromptTooltip: "Dùng để loại bỏ rõ ràng nội dung hoặc đặc điểm mà người dùng không muốn xuất hiện trong kết quả đầu ra",
        imageRatio: "Tỷ lệ ảnh",
        generateImageBtn: "Tạo ngay",
        shengchengjieguo: "Kết quả tạo",
        generateImageLoadingTip: "Đang tạo, vui lòng không nhấn lại hoặc đóng...",
        Tooltip: "Hãy tạo ý tưởng của bạn với AI",
        saveToMaterial: "Lưu vào tài liệu",
        publish: "Phát ngay",
        download: "Tải",
        generateHistory: "Lịch sử tạo",
        hide: "Thu gọn",
        cancel: "Hủy",
        useExpand: "Sử dụng mở rộng",
        all: "Tất cả",
        delete: "Xóa",
        loadMore: "Tải thêm",
        aiTip: "Nội dung được tạo bởi mô hình trí tuệ nhân tạo, không đại diện cho quan điểm, lập trường hoặc thái độ của nền tảng, vui lòng sử dụng nội dung AI một cách hợp lý và tuân thủ quy định",
        operationSuccess: "Thao tác thành công",
        moveGroup: "Chuyển nhóm",
        groupName: "Tên nhóm",
        pleaseSelectGroup: "Vui lòng chọn tên nhóm！",
        shenhe: "Duyệt",
        shenheStatus: "Trạng thái duyệt",
        shenheSuccess: "Đã duyệt",
        shenheRefuse: "Từ chối duyệt",
        pleaseSelectShenheStatus: "Vui lòng chọn trạng thái duyệt！",
        shenheRemark: "Ghi chú duyệt",
        pleaseInputShenheRemark: "Vui lòng nhập ghi chú duyệt！",
        pleaseInputFileName: "Vui lòng nhập tên tệp！",
        whitespace: "Lỗi đặt tên, tên tệp không được có khoảng trắng！",
        dataError: "Dữ liệu sai！",
        confirmDelete: "Xác nhận xóa",
        confirm: "Xác nhận",
        deleteFolder: "Xóa thư mục",
        add: "Thêm",
        edit: "Chỉnh sửa",
        fileName: "Tên tệp",
        group: "Nhóm",
        resolution: "Độ phân giải",
        type: "Loại",
        image: "Ảnh",
        music: "Âm nhạc",
        video: "Video",
        uploadTime: "Thời gian tải lên",
        uploadUser: "Người tải lên",
        checkTime: "Thời gian duyệt",
        checkUser: "Người duyệt",
    },
    setting: {
        nameempty: "Tên không được để trống",
        heightempty: "Chiều cao không được để trống",
        widthempty: "Chiều rộng không được để trống",
        resolutionratio: "Độ phân giải",
        name: "Tên",
        opteration: "Thao tác",
        compile: "Chỉnh sửa",
        delete: "Xóa",
        newz: "Thêm mới",
        compileratio: "Chỉnh sửa độ phân giải",
        sheizhifenbianlvmingcheng: "Đặt tên độ phân giải",
        shezhigaodu: "Đặt chiều cao",
        shezhikuandu: "Đặt chiều rộng",
        xinzengfenbianlv: "Thêm độ phân giải mới",
        bianma: "Mã hóa",
        bianjizhongduanmingcheng: "Chỉnh sửa tên thiết bị đầu cuối",
        xinzengzhongduan: "Thêm thiết bị đầu cuối mới",
        selectPrimaryColor: 'Chọn màu chủ đề',
        fullScreen: 'Toàn màn hình',
        exitFullScreen: 'Thoát toàn màn hình',
    },
    tabs: {
        refresh: 'Làm mới',
        refreshAll: 'Làm mới tất cả',
        close: 'Đóng',
        closeOthers: 'Đóng các tab khác',
        closeAll: 'Đóng tất cả',
        closeLeft: 'Đóng tab bên trái',
        closeRight: 'Đóng tab bên phải',
    },
    errorPage: {
        needLogin: 'Bạn chưa đăng nhập！',
        pageNotFound: 'Trang bạn truy cập không tồn tại！',
        redirectTo: 'Chuyển hướng đến',
        orReturn: 'Hoặc quay lại',
        previousStep: 'Bước trước',
    },
    headerUs: {
        systemNotice: "Thông báo hệ thống",
        allNotices: "Tất cả thông báo",
        viewAllMessages: "Xem tất cả tin nhắn",
        contactUs: "Liên hệ chúng tôi",
        operationSuccess: "Thao tác thành công！",
        leaveMessage: "Tôi muốn gửi tin nhắn",
        messageTitle: "Tiêu đề",
        messageTitleTip: "Vui lòng nhập tiêu đề！",
        messageContentTip: "Trong 150 ký tự",
        submit: "Gửi",
        markAsRead: "Đánh dấu đã đọc",
        success: "Thao tác thành công！"
    },
    material: {
        allMaterial: "Tất cả tài liệu",
        defaultGroup: "Nhóm mặc định",
        auditStatus: "Trạng thái duyệt",
        auditPassed: "Đã duyệt",
        auditRejected: "Từ chối duyệt",
        pendingAudit: "Chờ duyệt",
        all: "Tất cả",
        operateSuccess: "Thao tác thành công！",
        pleaseSelectMaterial: "Vui lòng chọn tài liệu！",
        moveGroup: "Chuyển nhóm",
        pleaseSelectGroup: "Vui lòng chọn nhóm！",
        batchPublish: "Phát hàng loạt",
        batchRecall: "Thu hồi hàng loạt",
        batchDelete: "Xóa hàng loạt",
        materialList: "Danh sách tài liệu",
        uploadMaterial: "Tải lên tài liệu",
        materialType: "Loại tài liệu",
        pleaseInputMaterialName: "Vui lòng nhập tên tài liệu",
        selectAll: "Chọn tất cả",
        confirmDeleteSelectedMaterial: "Xác nhận xóa tài liệu đã chọn？",
        deleteSuccess: "Xóa thành công",
        delete: "Xóa",
        publish: "Phát",
        recall: "Thu hồi",
        confirmRecallSelectedMaterial: "Xác nhận thu hồi tài liệu đã chọn？",
        pleaseSelectMaterialGroup: "Vui lòng chọn nhóm tài liệu！",
        recallSuccess: "Thu hồi thành công",
        publishSuccess: "Phát thành công",
        batchOperate: "Thao tác hàng loạt",
        item: "bản ghi",
        confirmDelete: "Xác nhận xóa？",
        edit: "Chỉnh sửa",
        confirmRecall: "Xác nhận thu hồi？",
        unaudited: "Chưa duyệt",
        notPassed: "Không duyệt",
        operate: "Thao tác",
        resolution: "Độ phân giải",
        none: "Không có",
        confirm: 'Xác nhận',
        cancel: 'Hủy',
        AICreation: "Tạo bằng AI",
    },
    uploadFile: {
        operationSuccess: "Thao tác thành công",
        uploadFile: "Quản lý tải lên",
        uploadSuccess: "Tải lên thành công",
        uploadCompleted: "Tải lên hoàn tất",
        uploadFail: "Tải lên thất bại",
        ConversionFailed: "Chuyển đổi thất bại！",
        loading: "Đang tải...",
        beQueuing: "Đang trong hàng chờ...",
        Uploading: "Đang tải lên...",
        ConversionIng: "Đang chuyển đổi...",
        ConventionalResources: "Tài nguyên thông thường",
        DocumentResources: "Tài nguyên tài liệu",
        complete: "Hoàn tất",
        upload: "Tải lên",
        fileSizeWraning01: "Kích thước tài liệu vượt quá",
        fileSizeWraning02: "Vui lòng sửa đổi và tải lên lại！",
        fileIsEmpty: "Tệp trống",
        uploadFileTip: "Định dạng tệp không được hỗ trợ",
        unablePreview: "Chưa thêm thành công vào thư viện tài liệu, không thể xem trước",
        confirmDelete: "Xác nhận xóa？",
        deleteSuccess: "Xóa thành công",
        delete: "Xóa",
        confirm: "Xác nhận",
        preview: "Xem trước",
        close: "Đóng",
        cancel: "Hủy",
        fileType: "Loại tệp",
        fileSize: "Kích thước tệp",
        conversionProgress: "Tiến độ chuyển đổi",
        progress: "Tiến độ",
        image: "Ảnh",
        video: "Video",
        audio: "Âm nhạc",
        limitTip01: "Tải lên một lần",
        limitTip02: "tệp",
        okTip: "Đang tải lên tài liệu, vui lòng không đóng cửa sổ sau này！",
        usableSize: 'Dung lượng khả dụng',
        sizeUnableTip: "Không gian lưu trữ khả dụng hiện tại không đủ, vui lòng xóa tài liệu không cần thiết kịp thời để tiết kiệm không gian hoặc liên hệ nhà phân phối để mở rộng dung lượng.",
        view: "Xem chi tiết",
        fileName: "Tên tệp",
    },
    template: {
        inputPlaceholder: 'Vui lòng nhập',
        selectPlaceholder: 'Vui lòng chọn',
        noAuths: "Không có quyền, vui lòng liên hệ quản trị viên",
        operationSuccess: "Thao tác thành công",
        total: "Tổng cộng",
        totalNum: "bản ghi",
        dan: "Đơn",
        shaung: "Đôi",
        pleaseSelectGroup: "Vui lòng chọn nhóm",
        preview: "Xem trước",
        free: "Miễn phí",
        use: "Sử dụng",
        dpi: 'Độ phân giải',
        delete: "Xóa",
        confirmDelete: "Xác nhận xóa",
        confirmDeleteSelectedTemplate: "Xác nhận xóa mẫu này",
        push: "Phát",
        pushConfirm: "Xác nhận phát lên mẫu công cộng？",
        pushRemovalConfirm: "Xác nhận gỡ khỏi mẫu công cộng？",
        templateOrderRecord: "Lịch sử đơn hàng mẫu",
        unpublished: "Chưa phát",
        auditing: "Đang duyệt",
        publishRejected: "Từ chối phát",
        publishSuccess: "Phát thành công",
        offShelf: "Gỡ khỏi kệ",
        公共模版: "Mẫu công cộng",
        我的模板: "Mẫu của tôi",
        共享记录: "Lịch sử chia sẻ",
        name: "Tên",
        pubdate: "Thời gian phát",
        keySeachTip: "Vui lòng nhập từ khóa",
        allGroup: "Tất cả nhóm",
        add: "Thêm",
        edit: "Chỉnh sửa",
        programName: "Tên chương trình",
        selectGroup: "Chọn nhóm",
    },
    checkManage: {
        total: "Tổng cộng",
        totalNum: "bản ghi",
        operationSuccess: "Thao tác thành công",
        checkUserLogs: "Lịch sử duyệt (Nhân viên thao tác)",
        checkLogs: "Lịch sử duyệt (Người duyệt)",
        sourceCheck: "Duyệt tài liệu",
        programCheck: "Duyệt chương trình",
        checkAll: "Chọn tất cả",
        auditPass: "Đã duyệt",
        auditRefuse: "Từ chối duyệt",
        auditPass01: "Đã duyệt",
        auditRefuse01: "Từ chối",
        auditRefuse02: "Từ chối duyệt",
        auditor: "Người duyệt",
        agentUserName: "Người phát",
        interrogationTime: "Thời gian nộp duyệt",
        checkTime: "Thời gian duyệt",
        checkName: "Tên được duyệt",
        checkType: "Loại duyệt",
        checkIp: "Địa chỉ IP nộp duyệt",
        checkReason: "Tin nhắn",
        checkStatus: "Nội dung thao tác",
        rangePicker: "Ngày duyệt",
        keyWord: "Từ khóa",
        all: "Tất cả",
        program: 'Chương trình',
        material: 'Tài liệu',
        dan: "Đơn",
        shaung: "Đôi",
        pleaseSelectProgram: "Vui lòng chọn chương trình!",
        pleaseSelectMaterial: "Vui lòng chọn tài liệu！",
        preview: "Xem trước",
        dpi: 'Độ phân giải',
        auditRefuseTip: "Vui lòng nhập lý do từ chối",
        unreviewed: "Chưa duyệt",
        notPassed: "Không duyệt",
        notUsed: "Chưa sử dụng",
        edit: "Chỉnh sửa",
        none: "Không có",
        name: "Tên",
        size: "Kích thước",
        type: "Loại",
        uploadTime: "Thời gian tải lên",
        uploadUser: "Người tải lên",
        checkUser: "Người duyệt",
        image: "Ảnh",
        music: "Âm nhạc",
        video: "Video",
    },
    systemSet: {
        total: "Tổng cộng",
        totalNum: "bản ghi",
        inputPlaceholder: 'Vui lòng nhập',
        selectPlaceholder: 'Vui lòng chọn',
        userList: "Thành viên tổ chức",
        roleList: "Quyền vai trò",
        department: "Cơ cấu tổ chức",
        diskInfo: "Không gian lưu trữ",
        approveSet: "Duyệt nội dung",
        logList: "Quản lý nhật ký",
        name: "Họ tên",
        account: "Tài khoản",
        userName: "Tên người dùng",
        phoneNumber: "Số điện thoại",
        role: "Vai trò",
        createTime: "Thời gian tạo",
        operation: "Thao tác",
        edit: "Chỉnh sửa",
        delete: "Xóa",
        addNew: "Thêm mới",
        add: "Thêm",
        resetPassword: "Đặt lại mật khẩu",
        confirmDelete: "Xác nhận xóa",
        departmentOrganization: "Cơ quan phòng ban",
        addNewUser: "Thêm người dùng mới",
        pleaseEnterUserName: "Vui lòng nhập tên người dùng",
        confirmPasswordNotMatch: "Mật khẩu xác nhận không khớp với mật khẩu đã nhập!",
        operationSuccess: "Thao tác thành công！",
        userNickname: "Tên người dùng",
        pleaseEnterUserNickname: "Vui lòng nhập tên người dùng",
        userNicknameRequired: "Tên người dùng không được để trống！",
        password: "Mật khẩu",
        pleaseEnterPassword: "Vui lòng nhập mật khẩu",
        passwordRequired: "Mật khẩu không được để trống！",
        passwordTip: "Mật khẩu của bạn có độ an toàn quá thấp (mật khẩu phải bao gồm 3 trong số các loại sau: chữ hoa, chữ thường, số, ký tự đặc biệt và có độ dài từ 8",
        confirmPassword: "Xác nhận mật khẩu",
        pleaseEnterPhoneNumber: "Vui lòng nhập số điện thoại",
        phoneNumberRequired: "Số điện thoại không được để trống！",
        phoneNumberFormatError: "Vui lòng nhập số điện thoại đúng định dạng！",
        roleRequired: "Vai trò không được để trống！",
        required: "Không được để trống！",
        departmentName: "Phòng ban",
        modifyPassword: "Đổi mật khẩu",
        newPassword: "Mật khẩu mới",
        pleaseEnterNewPassword: "Vui lòng nhập mật khẩu mới",
        pwdMessage: "Mật khẩu có độ dài 8~20 ký tự, không chứa khoảng trắng và phải bao gồm 3 trong số các loại sau: chữ hoa, chữ thường, số, ký tự đặc biệt",
        all: "Tất cả",
        noAuths: "Không có quyền, vui lòng liên hệ quản trị viên",
        departmentName01: "Tên phòng ban",
        image: "Ảnh",
        music: "Âm nhạc",
        video: "Video",
        buySize: "Số lượng mua",
        totalMoney: "Số tiền thanh toán",
        buycreateTime: "Thời gian mua",
        endTime: "Thời gian hết hạn",
        buyTypeStr: "Loại đơn hàng",
        sourceCheck: "Duyệt tài liệu",
        programCheck: "Duyệt chương trình",
        programName: "Tên chương trình",
        diskExpansion: "Khuyến nghị xóa tài liệu hết hạn/không sử dụng kịp thời trong quá trình sử dụng để đảm bảo dung lượng khả dụng của hệ thống. Nếu bạn cần dung lượng lớn hơn, bạn có thể liên hệ nhà cung cấp thiết bị để nhận dịch vụ mở rộng dung lượng lưu trữ đám mây. Dịch vụ này có thể phát sinh chi phí, vui lòng tham khảo thông tin từ nhà phân phối.",
        selectPermission: "Vui lòng chọn quyền",
        checkPermission: "Vui lòng chọn quyền",
        addRole: "Thêm vai trò",
        enterRoleName: "Vui lòng nhập tên vai trò",
        roleName: "Tên vai trò",
        roleNameRequired: "Tên vai trò không được để trống！",
        remark: "Ghi chú",
        enterRemark: "Vui lòng nhập ghi chú",
        permissionSetting: "Cài đặt quyền",
        deleteSuccess: "Xóa thành công！",
        confirmToDelete: "Xác nhận xóa？",
        orgName: "Tên tổ chức",
        orgNameRequired: "Tên tổ chức không được để trống！",
        orgRemark: "Ghi chú tổ chức",
        enterOrgRemark: "Vui lòng nhập ghi chú tổ chức",
        capacityUsage: "Trạng thái sử dụng dung lượng",
        usedCapacity: "Dung lượng đã sử dụng",
        totalCapacity: "Tổng dung lượng",
        remainingCapacity: "Dung lượng còn lại",
        capacityExpansion: "Mở rộng dung lượng",
        enable: "Bật",
        disable: "Tắt",
        userName01: "Tên người dùng",
        loginTime: "Thời gian đăng nhập",
        ipAddress: "Địa chỉ IP",
        loginResult: "Kết quả đăng nhập",
        selectDate: "Chọn ngày",
        enterDate: "Vui lòng chọn ngày",
        selectStartTime: "Vui lòng chọn thời gian bắt đầu",
        selectEndTime: "Vui lòng chọn thời gian kết thúc",
        enterUserName: "Vui lòng nhập tên người dùng",
        userCount: "Số người dùng",
        roleDesc: "Mô tả vai trò",
        roleAuthorization: "Cấp quyền vai trò",
        success: "Thành công",
        failure: "Thất bại",
        time: "Thời gian",
        operationContent: "Nội dung thao tác",
        playCount: "Số lần phát",
        playDuration: "Thời gian phát",
        selectDevice: "Chọn thiết bị",
        enterProgramName: "Vui lòng nhập tên chương trình",
        serialNumber: "Số thứ tự",
        publishContentName: "Tên nội dung phát",
        playMode: "Cách phát",
        cyclePlay: "Phát lặp",
        insertPlay: "Chèn phát",
        paddingPlay: "Phát đệm",
        playDeviceId: "ID thiết bị phát",
        playDeviceName: "Tên thiết bị phát",
        publishTime: "Thời gian phát",
        downloadStatus: "Trạng thái tải",
        notDownloaded: "Chưa tải",
        downloading: "Đang tải",
        downloadSucceeded: "Tải thành công",
        downloadFailed: "Tải thất bại",
        enterPublishContentName: "Vui lòng nhập tên nội dung phát",
        terminalId: "ID thiết bị đầu cuối",
        belongOrg: "Tổ chức thuộc về",
        reportTime: "Thời gian báo cáo",
        reportIp: "IP báo cáo",
        logInfo: "Thông tin nhật ký",
        details: "Chi tiết",
        confirmDeletion: "Xác nhận xóa？",
        logDetails: "Chi tiết nhật ký",
        download: "Tải",
        deptOrg: "Cơ quan phòng ban",
        query: "Tìm kiếm",
        queryByTerminalId: "Tìm kiếm theo ID thiết bị đầu cuối",
        batchDeleteLogs: "Xóa nhật ký hàng loạt",
        customTimeDeleteLogs: "Xóa nhật ký theo thời gian tùy chỉnh",
        selectTimeRangeFirst: "Vui lòng chọn khoảng thời gian trước",
        deleteAllDeviceLogsIfEmpty: "Nếu không nhập ID thiết bị, mặc định sẽ xóa nhật ký của tất cả thiết bị",
        enterDeviceIdToDeleteLogs: "Vui lòng nhập ID thiết bị cần xóa nhật ký",
        confirmDeleteAction: "Xác nhận xóa",
        selectDeleteRangeFirst: "Vui lòng chọn phạm vi xóa trước",
        networkConnectionFailed: "Kết nối mạng thất bại",
        playLog: "Nhật ký phát",
        publishLog: "Nhật ký phát",
        errorLog: "Nhật ký lỗi",
        operationLog: "Nhật ký thao tác",
        fileLog: "Nhật ký tệp",
        userOperateLog: "Nhật ký đăng nhập",
    },
    userManual: {
        userManual: "Hướng dẫn sử dụng",
        noData: "Không có dữ liệu",
    },
    systemNotice: {
        systemNotice: "Thông báo hệ thống",
        noData: "Không có dữ liệu",
        total: "Tổng cộng",
        totalNum: "bản ghi",
        "markAllRead": "Đánh dấu tất cả đã đọc",
        "deleteAll": "Xóa tất cả",
        "all": "Tất cả",
        "unread": "Chưa đọc",
        "read": "Đã đọc",
        "type": "Loại",
        "content": "Nội dung",
        "date": "Ngày",
        "status": "Trạng thái",
        "confirmDelete": "Xác nhận xóa？",
        "confirm": "Xác nhận",
        "cancel": "Hủy",
        "delete": "Xóa"
    }
};